import React, { Component } from "react"

/* PureComponents */
import { Chip } from '../components'

/* Constants */
import { utils, sound } from '../constants'
import { CHOICE } from "../constants/status"

/* Fields */
const BOXES = [0, 1]


/* Widget Rates */
class Rates extends Component {

    /* Get Color */
    getColor = value => {

        const { chips } = this.props

        let color = chips[0].color

        chips.forEach(item => {
            if (item.value <= value) {
                color = item.color
            }
        })

        return color
    }

    /* DRAW ANIMATION */
    _animation = (target) => {

        const { list, box } = this.props
        const final = list.filter(e => parseInt(e.box) === parseInt(box))

        return (
            <div className="animated-chips">
                {final.map((chip, index) => {
                    const color = this.getColor(chip.value)

                    if (chip.target === target) {
                        return (
                            <div className={`animated-chip ${chip.type === "add" ? "visible" : "hidden"}`} key={`${index}`}>
                                <Chip color={color} value={chip.value} />
                            </div>
                        )
                    }

                    return null
                })}
            </div>
        )
    }

    add = (target) => {

        const { status, selected, ante, setStake, list, setList, balance, game, chips, currency, volume, box, all } = this.props

        let stake = { ante: [...all.ante], bonus: [...all.bonus] }

        const secondBox = box ? 0 : 1
        let both = false

        if (status === "CHOICE" && chips[selected]) {
            let value = chips[selected].value

            if (target === 'ante') {
                if (!ante) {
                    const anteToAdd = all.ante[secondBox] ? all.ante[secondBox] : value
                    value = anteToAdd
                    stake.ante[box] = anteToAdd
                } else {
                    stake.ante[box] += value
                    if (stake.ante[secondBox]) {
                        stake.ante[secondBox] += value
                        both = true
                    }
                }
            }
            else {
                if (!ante) {
                    return
                }
                stake.bonus[box] += value
            }

            let totalAnte = 0
            if (stake.ante) {
                stake.ante.forEach(item => {
                    totalAnte = totalAnte + item
                })
            }

            let totalBonus = 0
            if (stake.bonus) {
                stake.bonus.forEach(item => {
                    totalBonus = totalBonus + item
                })
            }

            if ((totalAnte * 3.5 + totalBonus) > balance) {
                utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
                return
            }

            if ((stake.ante[box] > parseInt(game.max) && target === 'ante') || (stake.bonus[box] > parseInt(game.maxBonus) && target === 'bonus')) {
                if (target === 'ante') {
                    utils.toggleError(`${utils.translate("Maximum bid")} ${utils.getWithCurrency(game.max, currency)}`, "error", "maxbidante")
                }
                else {
                    utils.toggleError(`${utils.translate("Maximum bid for bonus")} ${utils.getWithCurrency(game.maxBonus, currency)}`, "error", "maxbidbonus")
                }
                return
            }

            setStake(stake)

            for (const tempBox of BOXES) {
                if (tempBox === box || both) {
                    list.push({ value, type: "add", target, box: tempBox, double: both })
                }
            }

            setList(list)

            if (volume) {
                sound.play('sound', 0.2)
            }
        }
    }

    /* DRAW ANTE */
    _ante = () => {

        const { ante, solution, result } = this.props
        const color = this.getColor(ante)

        const isHidden = solution === "FOLD" || (result && result.result === "lose")

        return (
            <div onClick={() => this.add('ante')} className="ante">
                <div className="ante-text">ANTE</div>
                <div className={`ante-chip-box ${(isHidden) ? "fold" : "hidden"}`}>{(ante && ante > 0) ? <Chip color={color} value={ante} /> : null}</div>
                {this._animation('ante')}
                {this._winRate("ante")}
            </div>
        )
    }

    /* ANTE & BONUS MULTIPLIER */
    _winRate = (type) => {

        const { result, bonusResult, ante, bonus } = this.props

        let isWinRate = type === "ante" ? (ante && result && result.anteMultiplier && parseInt(result.anteMultiplier) > 0) : (bonus && bonusResult && bonusResult.bonusMultiplier && parseInt(bonusResult.bonusMultiplier))

        if (isWinRate) {

            const value = type === "ante" ? ante * result.anteMultiplier : Number.isInteger(bonusResult.total) ? parseInt(bonusResult.total) : Number(bonusResult.total).toFixed(1)
            const multiplier = type === "ante" ? `${result.anteMultiplier}x` : bonusResult.bonusMultiplier === 5000 ? 'JACKPOT' : `${bonusResult.bonusMultiplier}x`

            const color = this.getColor(value)

            return (
                <div className="rate-win-ab">
                    <div className="rate-win-ab-text">{multiplier}</div>
                    <div className={`rate-win-ab-chip ${type === "bonus" ? "rate-win-ab-chip-bonus" : ""}`}>
                        <Chip color={color} value={value} />
                    </div>
                </div>
            )
        }
    }

    /* DRAW BONUS */
    _bonus = () => {

        const { ante, bonus, bonusResult, status } = this.props
        const color = this.getColor(bonus)

        const choice = status === CHOICE
        const isHidden = bonusResult && bonusResult.result === "lose"
        const active = ((choice && ante) || bonus) && !isHidden

        return (
            <div className="bonus" onClick={() => this.add('bonus')} style={{ opacity: active ? 1 : 0.5 }}>
                <div className="bonus-text">BONUS</div>
                <div className={`bonus-chip-box ${(isHidden) ? "fold" : "hidden"}`}>{(ante && ante > 0) ? <Chip color={color} value={bonus} /> : null}</div>
                {this._animation('bonus')}
                {this._winRate("bonus")}
            </div>
        )
    }

    /* BET MULTIPLIER */
    _winBet = () => {

        const { bet, result, game } = this.props

        if (bet && result && result.betMultiplier && parseInt(result.betMultiplier) > 0) {

            const maxPay = game && game.maxPay && parseFloat(game.maxPay) > 0 ? parseFloat(game.maxPay) : 0
            const value = maxPay < parseFloat(bet * result.betMultiplier) ? maxPay : bet * result.betMultiplier

            const color = this.getColor(value)

            return (
                <div className="rate-win-bet">
                    <div className="rate-win-bet-text">{result.betMultiplier}x</div>
                    <div className="rate-win-bet-chip">
                        <Chip color={color} value={value} />
                    </div>
                </div>
            )
        }
    }


    /* Draw BET */
    _bet = () => {

        const { status, bet, solution, result, bottomBet } = this.props
        const color = this.getColor(bet)

        return (
            <div onClick={() => bottomBet()} className="bet" style={{ opacity: status === "CHOICE" ? 0.6 : 1 }}>
                <div className="bet-text">BET</div>
                {(bet && bet > 0) ? <div className={`bet-chip-box ${(solution === "FOLD" || (result && result.result === "lose")) ? "fold" : "hidden"}`}> <Chip color={color} value={bet} /></div> : null}
                {this._winBet()}
            </div>
        )
    }


    /* Draw Buy */
    _buy = () => {
        const { ante, chip } = this.props
        const value = ante / 2
        const color = this.getColor(value)

        if (chip) {
            return (
                <div className="rate-buy">
                    <Chip value={value} color={color} />
                </div>
            )
        }
    }

    render = () => {

        const { status, ante, gameJackpot } = this.props

        return (
            <div className="rates" style={{ opacity: status !== "CHOICE" && ante === 0 ? 0.3 : 1 }}>
                {gameJackpot ? this._bonus() : null}
                {this._ante()}
                {this._bet()}
                {this._buy()}
            </div>
        )
    }

}

export default Rates